import * as React from 'react';
import { useCallback } from 'react';
import { getLinkWithCookies, openOpinionLabPage } from 'utility/opinion-lab';
import { useStores } from 'utility/hooks';
import { trackAnalyticsList } from 'utility';
import { MessagingCardIconAndLabel } from 'components/shared';
import { FlightsFeedback } from 'types/search/listings';

interface OpinionLabListingsProps {
  flightsFeedback: FlightsFeedback;
}

export const OpinionLabListing = ({ flightsFeedback }: OpinionLabListingsProps) => {
  const { analytics, context } = useStores();
  const { feedbackLinkAction, iconAndLabel } = flightsFeedback;
  const link =
    feedbackLinkAction.relativeURI &&
    feedbackLinkAction.relativeURI.value &&
    getLinkWithCookies(feedbackLinkAction.relativeURI.value, context);
  const openOpinionLab = useCallback(() => {
    openOpinionLabPage(link);
    trackAnalyticsList(flightsFeedback.feedbackLinkAction.analyticsList, analytics);
  }, [link, flightsFeedback.feedbackLinkAction.analyticsList, analytics]);

  return (
    <MessagingCardIconAndLabel
      icon={iconAndLabel.icon}
      label={iconAndLabel.label}
      linkText={feedbackLinkAction.displayAction}
      withBackground={true}
      classes="all-b-margin-three"
      handleClick={openOpinionLab}
      testid="opinion-lab-listing"
      ariaLabel={iconAndLabel.accessibility}
    />
  );
};
